import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { carBrands } from "../../AppConstants";
import BodyContainer from "../Common/BodyContainer/BodyContainer";

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    width: "75%",
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "0px 15px"
    },
  },
  buttonRow: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  button: {
    width: "100%",
    backgroundColor: "white",
    border: "3px solid black",
    color: "black",
    boxShadow: "none",
    borderRadius: "0px",
    padding: "20px",
    fontWeight: "600",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      boxShadow: "none",
    },
  },
}));

export default function NewUsedCar(props) {
  const history = useHistory();
  const classes = useStyles();
  const fontFamily =
    props.brand?.name === carBrands.jaguar.title ? "Jaguar-Secondary" : "LandRover-Secondary";
  const headingFont =
    props.brand?.name === carBrands.jaguar.title ? "Jaguar" : "LandRover";

  const handleSelectLocation = useCallback(
    (permalink) => {
      props.reactGA.event({
        category: "Location",
        action: "Select",
        label: permalink,
      });
      history.push(`/${props.brand.link}/${props.brandCondition}/${permalink}`);
    },
    [props.reactGA, props.brand?.link, props.brandCondition, history]
  );

  return (
    <BodyContainer
      {...props}
      childComponent={
        <React.Fragment>
          <div className={classes.contentWrapper}>
              <div className="col">
                <h4 style={{ fontFamily: headingFont, paddingBottom: "10px", marginTop: "20px"}}>
                  Waar wordt u graag verder geholpen?
                </h4>
              </div>
              <div className={classes.buttonRow}>
                {props.brand.locations.map((location) => (
                  <Button
                    key={location.permalink}
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    style={{ fontFamily }}
                    onClick={() => handleSelectLocation(location.permalink)}
                  >
                    {location.name}
                  </Button>
                ))}
              </div>
            </div>
        </React.Fragment>
      }
    />
  );
}
